import React, { useEffect, useState } from "react";
import "tailwindcss/tailwind.css";
import time from "../../Assets/updatedtimetrackimage.jpg";
import { useDispatch, useSelector } from "react-redux";
import {
  requestBackgroundImage,
  requestLoginAction,
  setResetStateLogin,
} from "../../Redux/LoginState/LoginActionCreator";
import LoginForm from "./LoginForm";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import LOCAL_KEYS, { setToLocalStorage } from "../../helpers/Localstorage";
import Swal from "sweetalert2";
import { requestGetFileAction } from "../../Redux/FileState/uploadFileActionCreator";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import { typeOfApplication } from "../../Constants";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dynamicImages, setDynamicImages] = useState([time]);
  const { loginResponse, isLoading, loginError } = useSelector(
    (state) => state.LoginReducer
  );
  const BackgroundImageReducer = useSelector((state) => state.FileReducer);

  useEffect(() => {
    if (loginResponse !== null) {
      // If we get access denied message, show error and reset
      if (loginResponse.message === "Access denied") {
        Swal.fire({
          title: "Error",
          text: "Access denied. Please check your credentials.",
          icon: "error",
          confirmButtonText: "Ok",
        });
        dispatch(setResetStateLogin());
        return;
      }

      // Check if userDetails exists and has acctType
      if (loginResponse.userDetails && loginResponse.userDetails.acctType) {
        const userType = loginResponse.userDetails.acctType.toUpperCase();
        // Normalize both cases to "ADMIN"
        if (["ADMIN", "ADMIN"].includes(userType)) {
          // Store the normalized value
          const normalizedUserDetails = {
            ...loginResponse.userDetails,
            acctType: "ADMIN"
          };

          setToLocalStorage(LOCAL_KEYS.ACCESS_TOKEN, loginResponse.access_token);
          setToLocalStorage(LOCAL_KEYS.REFRESH_TOKEN, loginResponse.refresh_token);
          setToLocalStorage(LOCAL_KEYS.USER_DETAILS, normalizedUserDetails);

          if (loginResponse.message) {
            setToLocalStorage(LOCAL_KEYS.EXPIRY, true);
            toast.error("Your password is expired please reset your password");
            dispatch(setResetStateLogin());
          } else {
            toast.success("Login successful");
            navigate("/", { replace: true });
          }
        } else {
          Swal.fire({
            title: "Error",
            text: "Invalid User Type",
            icon: "error",
            confirmButtonText: "Ok",
          });
          dispatch(setResetStateLogin());
        }
      } else {
        // Handle case where userDetails is null
        Swal.fire({
          title: "Error",
          text: "Invalid user details",
          icon: "error",
          confirmButtonText: "Ok",
        });
        dispatch(setResetStateLogin());
      }
    }
  }, [loginResponse]);

  useEffect(() => {
    if (loginError && !isLoading) {
      toast.error(loginError?.message);
      dispatch(setResetStateLogin());
    }
  }, [loginError]);

  // useEffect(() => {
  //   dispatch(requestBackgroundImage());
  // }, []);

  // useEffect(() => {
  //   if (
  //     BackgroundImageReducer?.response &&
  //     BackgroundImageReducer?.response?.blobUrl &&
  //     !BackgroundImageReducer?.loading
  //   ) {
  //     setDynamicImages([BackgroundImageReducer?.response?.blobUrl, time]);
  //   }
  // }, [BackgroundImageReducer]);

  const settings = {
    dots: false,
    fade: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    waitForAnimate: false,
  };

  return (
    <div className="flex min-h-screen">
      {/* Hide image section on small screens */}
      <div className="hidden sm:flex w-10/12 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0  to-slate-800 opacity-75"></div>
          {dynamicImages.map((img, index) => (
            <img
              key={index}
              className="h-full w-full object-cover"
              src={img}
              alt={`Background ${index}`}
            />
          ))}
        </div>
       
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-gray-900 to-transparent"></div>
      </div>

      {/* Make login form full width on small screens */}
      <div className="w-full sm:w-1/3 flex items-center justify-center p-6 h-[80vh]">
        <LoginForm />
      </div>
    </div>

  );
};

export default Login;
